import React from "react";
import { Routes, Route, useParams, useNavigate } from "react-router-dom";
import Layout from "../layouts/authLayout/authLayout";
import About from "../views/auth/about";
import NotFound from "../components/notfound";
import Login from "../views/auth/login";
import InstagramCallback from "../views/auth/instagram-callback";
import Home from "../pages/home";
import RegistrationSteps from "../pages/registration-steps/RegistrationSteps";
import TourPage from "../pages/tour/TourPage";
import DashboardLayout from "../layouts/userLayout/userLayout";
import PublicJobLayout from "../layouts/publicJobLayout/PublicJobLayout";
import JobDetailLayout from "../layouts/jobDetailLayout/JobDetailLayout";
import DashboardHome from "../pages/dashboard/Dashboard";
import Community from "../pages/community";
import Comparison from "../pages/comparison/Comparison";
import Jobs from "../pages/jobs";
import JobDetail from "../views/auth/jobs/jobDetail";
import SubscriptionMembership from "../pages/subscription-membership/SubscriptionMembership";
import Investment from "../pages/invest/Investment";
import Profile from "../pages/profile/profile";
import ContactUs from "../pages/profile/contact-us/contact";
import Notification from "../pages/notification/notification";
import Search from "../pages/search/Search";
import SearchDetail from "../pages/search/SearchDetail";
import Relocation from "../pages/relocation/relocation";
import ProtectedRoute from "../components/ProtectedRoute";
import Newsletter from "../pages/newsletter/newsletter";
import PostDetailModal from "../pages/community/components/post-detail-modal/PostDetailModal";
import Unsubscribe from "../pages/unsubscribe/Unsubscribe";
import PollVoteResult from "../pages/poll/PollVoteResult";
import PollVoteForm from "../pages/poll/PollVoteForm";
import AppGuide from "../pages/appGuide/AppGuide";

import FullMapPage from "../components/Map/FullMapPage";
import Salary from "../pages/salaries-tax/salaries/salaries";
import LifeInsurance from "../pages/calculator/life-insurance/life-insurance";
import HomeInsurance from "../pages/calculator/home-insurance/home-insurance";
import RetirementCalculator from "../pages/calculator/retirementCalculator/retirementCalculator";
import Testimonial from "../views/auth/testimonial";
import StudentLoan from "../pages/calculator/student-loan/student-loan";
import MortgageCalculator from "../pages/mortgage-calculator/mortgage";
import TaxPage from "../pages/salaries-tax/tax/tax";
import SalariesTaxWrapper from "../pages/salaries-tax/SalariesTaxWrapper";
import Success from "../pages/sucess/success";
import Trial from "../pages/trial/Trial";
import Discounts from "../pages/discounts/discounts";
import Referral from "../pages/profile/referral/referral";
import CancelPage from "../pages/cancel/cancel";
import Salarys from "../views/auth/salaries/salaries";
import Comparisons from "../views/auth/comparison/Comparison";
import CityComparison from "../views/auth/city-comparision/city-comparision";
import Products from "../pages/shop/products/products";
import ProductDetail from "../pages/shop/products-detail/products-detail";
import Checkout from "../pages/shop/checkout/checkout";
import Cart from "../pages/shop/cart/cart";
import Orders from "../pages/shop/myorders/myorders";
import OrderDetails from "../pages/shop/orderdetail/orderdetail";
import Messaging from "../pages/messaging/Messaging";
import HospitalJobApply from "../pages/jobs/components/JobCard/ApplyJob";
import JobsDetail from "../pages/jobs/components/JobCard/jobdetail";
import Blogs from "../pages/blogs/Blogs";
import BlogDetail from "../pages/blogs/BlogDetail";
import Mentorship from "../pages/mentorship/Mentorship";
// Placeholder components for missing routes
const Features = () => (
  <div className="container mt-5 pt-5">
    <h1>Features Page</h1>
    <p>Coming Soon...</p>
  </div>
);
// const Testimonial = () => <div className="container mt-5 pt-5"><h1>Testimonials</h1><p>Coming Soon...</p></div>;
const Pricing = () => (
  <div className="container mt-5 pt-5">
    <h1>Pricing</h1>
    <p>Coming Soon...</p>
  </div>
);

/**
 * Route wrapper for the post-detail deep links (`notification/:id` and
 * `community/:id`). Reads the post id from the URL and renders the shared
 * PostDetailModal so the detail experience is identical everywhere. Closing the
 * modal returns to the notifications list (for /notification/*) or the feed.
 */
const PostDetailRoute = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const handleClose = () => {
    if (window.location.pathname.startsWith("/notification/")) {
      navigate("/notification");
    } else {
      navigate("/community");
    }
  };

  return <PostDetailModal show postId={id} onClose={handleClose} />;
};

const AppRoutes = () => {
  return (
    <Routes>
      {/* Dashboard routes (use only DashboardLayout) */}
      <Route
        path="dashboard/*"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardHome />} />

        {/* Future dashboard routes go here, e.g.: */}
        {/* <Route path="reports" element={<Reports />} /> */}
      </Route>
      {/* Dashboard routes (only DashboardLayout applies) */}
      <Route
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route path="search" element={<Search />} />
        <Route path="search/details/:id" element={<SearchDetail />} />
        <Route path="jobs" element={<Jobs />} />
        <Route path="full-map" element={<FullMapPage />} />
        <Route path="relocation" element={<Relocation />} />
        <Route path="community" element={<Community />} />
        <Route path="mentorship" element={<Mentorship />} />
        <Route path="comparison" element={<Comparison />} />
        <Route path="tour" element={<TourPage />} />
        <Route
          path="profile/subscription"
          element={<SubscriptionMembership />}
        />
        <Route path="salaries-paychecks" element={<SalariesTaxWrapper />} />
        <Route path="salaries-paychecks/salaries" element={<Salary />} />
        <Route path="salaries-paychecks/tax" element={<TaxPage />} />
        <Route path="calculators/invest" element={<Investment />} />
        <Route path="profile" element={<Profile />} />
        <Route path="notification" element={<Notification />} />
        <Route path="contact-us" element={<ContactUs />} />
        <Route path="newsletter" element={<Newsletter />} />
        <Route path="notification/:id" element={<PostDetailRoute />} />
        <Route path="community/:id" element={<PostDetailRoute />} />
        <Route path="messaging" element={<Messaging />} />
        <Route path="messaging/:userId" element={<Messaging />} />
        <Route path="calculators/life-insurance" element={<LifeInsurance />} />
        <Route path="calculators/home-insurance" element={<HomeInsurance />} />
        <Route path="calculators/studentloan" element={<StudentLoan />} />
        <Route path="mortgage" element={<MortgageCalculator />} />
        <Route path="blog" element={<Blogs />} />
        <Route path="blog/:slug" element={<BlogDetail />} />
        <Route path="referral" element={<Referral />} />
        <Route path="shop/products" element={<Products />} />
        <Route path="shop/cart" element={<Cart />} />
        <Route path="shop/checkout" element={<Checkout />} />
        <Route path="shop/my-orders" element={<Orders />} />
        <Route
          path="/shop/products-detail/:id"
          element={<ProductDetail />}
        />
        <Route
          path="/shop/order-detail/:id"
          element={<OrderDetails />}
        />
        <Route
          path="calculators/retirement"
          element={<RetirementCalculator />}
        />
        <Route path="/discounts" element={<Discounts />} />
        <Route path="/cancel" element={<CancelPage />} />
        <Route path="/success" element={<Success />} />
        <Route path="/trial" element={<Trial />} />
        <Route path="app-guide" element={<AppGuide />} />
      </Route>

      {/* Tour page - Protected route (requires authentication after profile completion) */}
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="tour" element={<TourPage />} />
      </Route>

      {/* Job Application - Protected route with DashboardLayout */}
      <Route
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/jobs/apply/:id" element={<HospitalJobApply />} />
      </Route>

      {/* Job Detail - guests can view the page itself (e.g. via a shared
          link); JobsDetail gates any auth-only action behind a login prompt.
          JobDetailLayout picks the dashboard chrome for logged-in users and
          the lighter public-job chrome for guests. */}
      <Route
        element={
          <ProtectedRoute allowGuest>
            <JobDetailLayout />
          </ProtectedRoute>
        }
      >
        <Route path="job-detail/:id" element={<JobsDetail />} />
      </Route>

      {/* Public Job Detail route with sidebar and header */}
      <Route element={<PublicJobLayout />}>
        <Route path="/jobs/:slug" element={<JobDetail />} />
      </Route>

      {/* General/public routes (only Layout applies) */}
      <Route element={<Layout />}>
        {/* Default route → Home */}
        {/* <Route index element={<Home />} /> */}
        <Route index element={<Login />} />

        <Route path="registration" element={<RegistrationSteps />} />
        <Route path="testimonial" element={<Testimonial />} />
        <Route path="salaries" element={<Salarys />} />
        <Route path="comparisons" element={<Comparisons />} />
        <Route path="city-comparison" element={<CityComparison />} />
        <Route path="share/:token" element={<CityComparison />} />

        {/* <Route path="home" element={<Home />} /> */}

        {/* <Route path="about" element={<About />} />
    <Route path="features" element={<Features />} />
    <Route path="testimonial" element={<Testimonial />} />
    <Route path="pricing" element={<Pricing />} /> */}
        <Route path="login" element={<Login />} />
        <Route path="instagram-callback" element={<InstagramCallback />} />
        <Route path="unsubscribe" element={<Unsubscribe />} />
        <Route path="poll/vote" element={<PollVoteResult />} />
        <Route path="poll/take" element={<PollVoteForm />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
